import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController } from 'ionic-angular';
import { CalendarModal, CalendarModalOptions, CalendarResult } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { HttpClient} from '@angular/common/http';

@IonicPage()
@Component({
  selector: 'page-adminRequest',
  templateUrl: 'adminRequest.html',
})
export class AdminRequestPage {
  private userId: any;
  private date: any;
  private type: any;
  private companyId: any;
  private TimeCard = [];
  private Dates = [];
  private Requests = [];
  disabled: boolean = false;
  private tid: any;
  private id: any;
  private requestInput = [];
  private requestInput1 = [];
  private GetUsersTimes = [];
  public tabIndex = 1;
  public agreeR = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {
  }

  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = 'Request';
    this.data.currentTabName = 'Хүсэлтийн дэлгэрэнгүй';
  }

  ionViewDidLoad() {
    this.companyId = this.data.companyId;
    this.userId = this.data.userId;
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    let defYear = now.getFullYear();
    this.rest.Dates(this.companyId).subscribe(res => {
      this.Dates = res;
      for(let i = 0; i < this.Dates.length;i++) {
        if(this.Dates[i].begin_day <= nowdate && this.Dates[i].end_day >= nowdate) {
          this.date = this.Dates[i].id;
        }
      }
      this.getTimeCard();
    });

  }

  getTimeCard() {
    this.rest.TimeCard(this.userId, this.date, this.companyId).subscribe(res => {
      this.TimeCard = res;
      this.type = 1;
      this.adminRequest_sent();
    });
  }

  getHuselt(event: any){
    this.type = event;
    this.adminRequest_sent();
    this.tabIndex == 1;
  }

  adminRequest_sent(){
    this.agreeR = [];
    this.rest.GetRequest(this.userId, this.date, this.type).subscribe(res => {
      this.Requests = res;
      setTimeout(() => {
        if(res.huselt.length > 0) {
          let table = document.getElementById('allHuselt');
          //if(this.tabIndex == 1) {
            /*for(let i=0;i<table.getElementsByTagName('tr').length;i++) {
              if(table.getElementsByTagName('tr')[i].id == 'huselt-0-' + i) {
                table.getElementsByTagName('tr')[i].style.display = 'block';
              } else {
                table.getElementsByTagName('tr')[i].style.display = 'none';
              }
            }*/
          //  document.getElementById('tableWord').innerHTML = 'Шийдвэрлэгдээгүй хүсэлтүүд';
          //} else {
            /*for(let i=0;i<table.getElementsByTagName('tr').length;i++) {
              if(table.getElementsByTagName('tr')[i].id == 'huselt-0-' + i) {
                table.getElementsByTagName('tr')[i].style.display = 'none';
              } else {
                table.getElementsByTagName('tr')[i].style.display = 'block';
              }
            }*/
           // document.getElementById('tableWord').innerHTML = 'Шийдвэрлэгдсэн хүсэлтүүд';
          //}          
          for(let i=0;i<res.huselt.length;i++) {
            if(this.tabIndex == 1) {
              if(res.huselt[i].is_solved == 0) {
                this.agreeR.push(res.huselt[i]);
              }
            } else {
              if(res.huselt[i].is_solved == 1) {
                this.agreeR.push(res.huselt[i]);
              }
            }
          }
        }
      }, 1000);
    });
    this.rest.GetUsersTimes(this.data.companyId, this.date).subscribe(res => {
      this.GetUsersTimes = res;
    });
  }

  setTabIndex(id: any) {
    this.tabIndex = id;
    if(this.tabIndex == 1) {
      this.adminRequest_sent();
    } else if(this.tabIndex == 2) {
      this.adminRequest_sent();
    }
  }

  onSelectClicked(value) {
    setTimeout(() => {
      document.getElementsByClassName('alert-radio-group')[0]
              .querySelector('[aria-checked="true"]')
              .scrollIntoView();
    }, 500);
  }

  agreeReg(userId: any, tid: any, type: any, name: any){
    this.rest.timeRequestAgree(userId, tid, type).subscribe(res => {
      if(res.msg == 'ok') {
        this.showToast('Таны сонгосон хүсэлтийг амжилттай зөвшөөрлөө.');
        this.adminRequest_sent();
      } else if(res.msg == 'not arrived') {
        this.showToast1(name + ' тухайн өдөр ирээгүй байна.');
      } else {
        this.showToast1('Одоогоор ажиллахгүй.');
      }
    });
  }

  deleteReq(tid: any, index: any){
    if(this.requestInput[index] == null){
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
    }
    if(this.requestInput[index] != null){
      if(confirm('Та буцаахдаа итгэлтэй байна уу?')) {
        this.rest.updateRequest(tid, this.requestInput[index], 'tatgalzah').subscribe(res => {
          this.showToast('Таны сонгосон хүсэлтийг амжилттай буцаалаа.');
          this.adminRequest_sent();
        });
      }
    }
  }

  updateReq(tid: any, index: any){
    if(this.requestInput1[index] == null){
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
    }
    if(this.requestInput1[index] != null){
      if(confirm('Та сэргээхдээ итгэлтэй байна уу?')) {
        this.rest.updateRequest(tid, this.requestInput1[index], 'sergeeh').subscribe(res => {
          this.showToast('Таны сонгосон хүсэлтийг амжилттай сэргээлээ.');
          this.adminRequest_sent();
        });
      }
    }
  }

  today(){
    const options: CalendarModalOptions = {
      title: 'Цаглабар',
      monthFormat: 'YYYY Он MM Сар ',
      weekdays: ['Д', 'М', 'Л', 'П', 'Б', 'Б', 'Н'],
      weekStart: 1,
      defaultDate: new Date()
    };

    let myCalendar =  this.modalCtrl.create(CalendarModal, {
      options: options
    });

    myCalendar.present();

    myCalendar.onDidDismiss((date: CalendarResult, type: string) => {
    });
  }
  readminRequest_sent(){

  }


  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/adminRequest/adminRequest.ts